/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Label, HasPermission, Icon, Row } from "@fitinsur/components";

export default function accessGroupColumns({
  history,
  getDescription,
  setDialogConfirmation,
  setModalConfirmationDetails,
  handleSetAcessGroup,
}) {
  return [
    {
      title: getDescription("DOMAINS", 853),
      value: "accessGroup",
      key: "accessGroup",
			minWidth: 5,
			maxWidth: 5,
			component: (listItem) => {
        return (
          <Label wordWrap fontSize={14}>
            {listItem?.groupName}
          </Label>
        )
      }
		},
    {
      title: getDescription("DOMAINS", 852),
      value: "typeOfAccess",
      key: "typeOfAccess",
      minWidth: 5,
      maxWidth: 5,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return (
          <Label wordWrap fontSize={14}>
            {listItem?.behavior?.isExternalAccessGroup ? getDescription("DOMAINS", 800) : getDescription("DOMAINS", 801) || 'Não definido'}
          </Label>
        )
      }
    },
    {
      title: getDescription("DOMAINS", 827),
      key: "action",
      minWidth: 5,
      maxWidth: 5,
      paddingRight: 5,
      component: (listItem) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
            <Row className="align-items-center justify-content-start" style={{ width: 65 }}>
              <HasPermission permission={true}>
                <Icon
                  name="edit"
                  title={getDescription("DOMAINS", 855)}
                  onClick={() => {
                    history.push(`/management/58/access-group/edit/${listItem?.idGroup}`);
                    window.location.reload();
                  }}
                />
                <Icon
                  name="trash"
                  title={getDescription("DOMAINS", 896)}
                  onClick={() => {
                    handleSetAcessGroup(listItem.idGroup);
                    setDialogConfirmation({ visible: true });
                    setModalConfirmationDetails({
                      text: getDescription("DOMAINS", 856),
                      textButtonConfirm: getDescription("DOMAINS", 815),
                      textButtonCancel: getDescription("DOMAINS", 816),
                      type: "accessGroup"
                    });
                  }}
                />
              </HasPermission>
            </Row>
          </div>
        )
      }
    }
  ];
}
